import { AtlasConversionV2PageLayout } from 'src/components/AtlasV2Components/AtlasV2PageLayouts/AtlasConversionV2PageLayout';
import GenericPageContainer from 'src/components/EntityPage/GenericPageContainer';

export default function getAtlasConversionV2PageLayout({ metricType }) {
  const conversionPageLayout = {
    purchaseRate: AtlasConversionV2PageLayout
  };
  return {
    CustomPageContainer: GenericPageContainer,
    enableComparison: false,
    widgets: [
      {
        name: 'AtlasConversionV2PageLayout',
        CustomComponent: conversionPageLayout[metricType],
        view: {}
      }
    ],
    containerStyle: {},
    dataConfig: {}
  };
}
